import '../css/Information.css';
import React, { useEffect, useState } from 'react';
import BaseView from "../components/BaseView";

function IndiaInstruments() {
    const [instruments, setInstruments] = useState([]);
    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [selectedExchange, setSelectedExchange] = useState('NSE');
    const LIMIT = 50;

    useEffect(() => {
        document.title = "India Instruments";
        fetchInstruments(0, selectedExchange);
    }, [selectedExchange]);

    const fetchInstruments = async (pageNumber, exchange) => {
        try {
            const res = await fetch('https://stockseyescloudrun-n2ermovi6q-el.a.run.app/searchInstruments', {
                method: 'POST',
                headers: {
                    'Authorization': 'your_api_key_here',
                    'origin': 'http://www.firsttrade.in',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    filterRequest: {
                        exchange: [exchange]
                    },
                    paginationDetails: {
                        offset: pageNumber * LIMIT,
                        limit: LIMIT
                    }
                })
            });

            const data = await res.json();
            setInstruments(data.instruments);
            setTotalCount(data.totalCount);
            setPage(pageNumber);
        } catch (error) {
            console.error("Failed to fetch instruments:", error);
        }
    };

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = "https://api.kite.trade/instruments";
        link.download = "instruments.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleExchangeChange = (e) => {
        const exchange = e.target.value;
        setSelectedExchange(exchange);
        setPage(0);
    };

    const totalPages = Math.ceil(totalCount / LIMIT);

    return (
        <BaseView>
            <div style={{ padding: '20px', textAlign: 'center', color:"white" }}>
                <h1>India Instruments</h1>
                <p style={{ fontSize: '16px', marginBottom: '20px' }}>
                    You can download the complete list of Indian instruments here.
                </p>
                <button
                    onClick={handleDownload}
                    style={downloadBtnStyle}
                    onMouseOver={e => e.target.style.backgroundColor = '#0056b3'}
                    onMouseOut={e => e.target.style.backgroundColor = '#007bff'}
                >
                    📥 Download All Instruments (CSV)
                </button>

                {/* Exchange Filter */}
                <div style={{ marginTop: '30px', marginBottom: '20px' }}>
                    <label htmlFor="exchange-select" style={{ marginRight: '10px', fontWeight: 'bold' }}>Filter by Exchange:</label>
                    <select
                        id="exchange-select"
                        value={selectedExchange}
                        onChange={handleExchangeChange}
                        style={{ padding: '8px 12px', fontSize: '14px', borderRadius: '4px', border: '1px solid #ccc', color:"black" }}
                    >
                        <option value="NSE">NSE</option>
                        <option value="BSE">BSE</option>
                        <option value="NFO">NFO</option>
                        <option value="MCX">MCX</option>
                        <option value="CDS">CDS</option>
                        <option value="BCD">BCD</option>
                    </select>
                </div>

                {/* Instrument Table */}
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ borderCollapse: 'collapse', width: '100%', marginBottom: '20px' }}>
                        <thead>
                        <tr style={{ backgroundColor: 'grey' }}>
                            <th style={cellStyle}>Symbol</th>
                            <th style={cellStyle}>Name</th>
                            <th style={cellStyle}>Exchange</th>
                            <th style={cellStyle}>Type</th>
                            <th style={cellStyle}>Segment</th>
                        </tr>
                        </thead>
                        <tbody>
                        {instruments.map((inst, index) => (
                            <tr key={index}>
                                <td style={cellStyle}>{inst.tradingsymbol}</td>
                                <td style={cellStyle}>{inst.name}</td>
                                <td style={cellStyle}>{inst.exchange}</td>
                                <td style={cellStyle}>{inst.instrument_type}</td>
                                <td style={cellStyle}>{inst.segment}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>

                    {/* Pagination Controls */}
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                        <button
                            disabled={page === 0}
                            onClick={() => fetchInstruments(page - 1, selectedExchange)}
                            style={navBtnStyle}
                        >
                            ⬅️ Previous
                        </button>
                        <span>Page {page + 1} of {totalPages}</span>
                        <button
                            disabled={(page + 1) >= totalPages}
                            onClick={() => fetchInstruments(page + 1, selectedExchange)}
                            style={navBtnStyle}
                        >
                            Next ➡️
                        </button>
                    </div>
                </div>
            </div>
        </BaseView>
    );
}

const cellStyle = {
    border: '1px solid #ddd',
    padding: '10px',
    textAlign: 'left',
    color: 'white',
};

const navBtnStyle = {
    padding: '8px 16px',
    fontSize: '14px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    cursor: 'pointer',
    backgroundColor: '#f9f9f9'
};

const downloadBtnStyle = {
    backgroundColor: '#007bff',
    color: 'white',
    fontSize: '16px',
    padding: '12px 24px',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease'
};

export default IndiaInstruments;
